export default __webpack_public_path__ + "static/logo-freshcells-systems-engineering-medium-103630df919b7b535130520ea2c8b459.jpg";